import IconGreat from './Great';
import IconGreatSearch from './GreatSearch';
import IconHug from './Hug';
import IconErrorPage from './ErrorPage';
import IconSad from './Sad';
import IconSadSearchHandsDown from './SadSearchHandsDown';
import IconSadSearchHandsUp from './SadSearchHandsUp';
import IconWarning from './Warning';

export { IconGreat, IconGreatSearch, IconHug, IconErrorPage, IconSad, IconSadSearchHandsDown, IconSadSearchHandsUp, IconWarning }

export const creturesIcons = { IconGreat, IconGreatSearch, IconHug, IconErrorPage, IconSad, IconSadSearchHandsDown, IconSadSearchHandsUp, IconWarning };